document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Product gallery thumbnails ---------------- */
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var mainImage = gallery.querySelector('[data-main-image]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!mainImage || !thumbs.length) return;

    function showThumb(thumb) {
      var fullSrc = thumb.getAttribute('data-full-src');
      if (fullSrc) mainImage.src = fullSrc;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showThumb(thumb); });
    });

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    function currentIndex() {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      return i === -1 ? 0 : i;
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var i = (currentIndex() - 1 + thumbs.length) % thumbs.length;
        showThumb(thumbs[i]);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var i = (currentIndex() + 1) % thumbs.length;
        showThumb(thumbs[i]);
      });
    }
  });

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------------- Search bar toggle ---------------- */
  var searchToggles = document.querySelectorAll('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchBar) {
    searchToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        searchBar.hidden = !searchBar.hidden;
        if (!searchBar.hidden) {
          var input = searchBar.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    });
  }

  /* ---------------- Hero slider ---------------- */
  var slider = document.querySelector('[data-hero-slider]');
  if (slider) {
    var track = slider.querySelector('.hero-slider__track');
    var slides = slider.querySelectorAll('[data-hero-slide]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    var nextBtn = slider.querySelector('[data-hero-next]');
    var current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (100 * current) + '%)';
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    if (slides.length > 1) {
      setInterval(function () { goTo(current + 1); }, 6000);
    }
  }

  /* ---------------- Featured collection tabs ---------------- */
  document.querySelectorAll('.featured-tabs').forEach(function (section) {
    var tabs = section.querySelectorAll('.featured-tabs__tab');
    var panels = section.querySelectorAll('.featured-tabs__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = section.querySelector('#' + target);
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  /* ---------------- Cart page quantity steppers ---------------- */
  document.querySelectorAll('.cart-item').forEach(function (item) {
    var input = item.querySelector('[data-qty-input]');
    var decreaseBtn = item.querySelector('[data-qty-decrease]');
    var increaseBtn = item.querySelector('[data-qty-increase]');
    if (!input) return;
    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        var val = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = val;
      });
    }
    if (increaseBtn) {
      increaseBtn.addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
      });
    }
  });

  /* ---------------- Product variant picker ---------------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('#ProductVariantsJson');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var variantIdInput = section.querySelector('[data-variant-id]');
    var mainImage = section.querySelector('[data-main-image]');
    var priceEl = section.querySelector('[data-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var addBtnText = section.querySelector('[data-add-to-cart-text]');
    var optionGroups = section.querySelectorAll('[data-option-selector]');

    // Build current selection from the variant that matches the pre-selected hidden input
    var currentVariant = variants.filter(function (v) {
      return String(v.id) === variantIdInput.value;
    })[0] || variants[0];
    var selectedOptions = currentVariant ? currentVariant.options.slice() : [];

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      })[0];
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) {
        addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = 'Unavailable';
        return;
      }

      variantIdInput.value = variant.id;

      // Price
      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="price price--sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="price price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceEl.innerHTML = '<span class="price">' + formatMoney(variant.price) + '</span>';
        }
      }

      // Availability
      addBtn.disabled = !variant.available;
      if (addBtnText) addBtnText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      // Sticky bar price sync
      var stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      // Image swap (color change) — only if this variant has its own image
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_1600x$1$2');
      }

      // Sync "selected value" label next to color option
      optionGroups.forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var labelEl = group.closest('.field').querySelector('[data-selected-value]');
        if (labelEl) labelEl.textContent = selectedOptions[index];
      });
    }

    optionGroups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      var buttons = group.querySelectorAll('[data-option-value]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedOptions[index] = btn.getAttribute('data-option-value');
          buttons.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          updateUI();
        });
      });
    });

    // Quantity stepper
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyDecrease = section.querySelector('[data-qty-decrease]');
    var qtyIncrease = section.querySelector('[data-qty-increase]');
    if (qtyInput) {
      if (qtyDecrease) {
        qtyDecrease.addEventListener('click', function () {
          qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
        });
      }
      if (qtyIncrease) {
        qtyIncrease.addEventListener('click', function () {
          qtyInput.value = parseInt(qtyInput.value, 10) + 1;
        });
      }
    }

    // Sticky mobile add-to-cart bar
    var stickyBar = section.querySelector('[data-sticky-bar]');
    var mainAddBtn = section.querySelector('[data-add-to-cart]');
    var stickyAddBtn = section.querySelector('[data-sticky-add-to-cart]');
    if (stickyBar && mainAddBtn) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(mainAddBtn);

      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function () {
          mainAddBtn.click();
        });
      }
    }
  });

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer-overlay');
  var cartIcon = document.querySelector('[data-cart-icon]');

  function openCartDrawer(e) {
    if (!cartDrawer) return;
    if (e) e.preventDefault();
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
  }
  if (cartIcon) cartIcon.addEventListener('click', openCartDrawer);
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  function renderCartDrawer(cart) {
    var content = document.getElementById('cart-drawer-content');
    if (!content) return;
    if (cart.item_count === 0) {
      content.innerHTML = '<h2 class="cart-drawer__title">Your Cart (0)</h2><p>Your cart is empty.</p>';
      return;
    }
    var itemsHtml = cart.items.map(function (item) {
      return '<li class="cart-drawer__item">' +
        '<img src="' + item.image + '" alt="' + item.product_title + '">' +
        '<div class="cart-drawer__item-info">' +
        '<a href="' + item.url + '">' + item.product_title + '</a>' +
        '<p>' + item.quantity + ' &times; ' + formatMoney(item.price) + '</p>' +
        '</div></li>';
    }).join('');
    content.innerHTML =
      '<h2 class="cart-drawer__title">Your Cart (' + cart.item_count + ')</h2>' +
      '<ul class="cart-drawer__items">' + itemsHtml + '</ul>' +
      '<p class="cart-drawer__subtotal">Subtotal: ' + formatMoney(cart.total_price) + '</p>' +
      '<a href="/cart" class="btn btn--outline btn--full">View Cart</a>' +
      '<a href="/checkout" class="btn btn--primary btn--full">Checkout</a>';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Intercept product form submits to add via AJAX and open the drawer */
  document.querySelectorAll('.product-form, .product-card form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // fall back to normal submit
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          renderCartDrawer(cart);
          openCartDrawer();
        })
        .catch(function () {
          form.submit(); // fallback for browsers without fetch or on error
        });
    });
  });

});
